import React from "react";
import { Navigate } from "react-router-dom";
const AdminPublicRoute = ({ children }) => {
  
        const temp = localStorage.getItem("name");

        if (temp) {
            return <Navigate to="/dashboard" />;
        }
    

    return children;
};

export default AdminPublicRoute;
